module.exports = __webpack_public_path__ + "img/address-sentosa.49a088fe.svg";